"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = require("vue");

var _vue2 = _interopRequireDefault(_vue);

var _vTooltip = require("v-tooltip");

var _vTooltip2 = _interopRequireDefault(_vTooltip);

var _html = require("linkifyjs/html");

var _html2 = _interopRequireDefault(_html);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vTooltip2.default); //
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    text: {
      required: false,
      default: ""
    },
    icon: {
      required: false,
      default: "info"
    },
    type: {
      required: false,
      default: "c-blue"
    }
  },

  data: function data() {
    return {
      show: false
    };
  },


  methods: {
    getLinkifiedDescription: function getLinkifiedDescription() {
      return (0, _html2.default)(this.text, {
        defaultProtocol: "https"
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/general/IconTooltip.vue
// module id = Jqfv
// module chunks = 0 1